import React from 'react';
import { CheckBox } from '../../Common';
import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip,
} from '@mui/material';
import "./index.css";

const commonTableCellProps = {
    align: "left",
    className: 'location-data',
    sx: { '&.MuiTableCell-root': { padding: "8px" } }
};

const tableCellSx = { '&.MuiTableCell-root': { padding: "8px" } };

const InstanceAssociationsTable = ({
    regionId,
    locations,
    columns,
    state,
    handleLocationCheck,
    comingFromUserForm,
    linkServiceProviders,
}) => {
    const checkboxDisabled = !state.enabledRegionIds.includes(regionId);

    return (
        <Grid
            key={regionId}
            container
            item
            direction="row"
            alignItems="center"
            sx={{ marginTop: "1%" }}
        >
            <TableContainer sx={{ maxHeight: "400px", overflowY: "auto" }} className='cylinderList'>
                <Table stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {(comingFromUserForm || linkServiceProviders) && (
                                <TableCell align='left' sx={{...tableCellSx}}>
                                    <Tooltip title={checkboxDisabled ? "Enable Region to assign all locations" : "Select All Locations"}>
                                        <span>
                                            <CheckBox
                                                checked={
                                                    state.regionIdsAllLocationsAssigned.includes(regionId)
                                                    || locations.every(l => state.assignedLocationIds.includes(l.id))
                                                }
                                                onChange={() => handleLocationCheck({ regionId, allLocationsChecked: true })}
                                                disabled={!state.enabledRegionIds.includes(regionId)}
                                                indeterminate={
                                                    locations.some(l => state.assignedLocationIds.includes(l.id))
                                                    && !locations.every(l => state.assignedLocationIds.includes(l.id))
                                                }
                                            />
                                        </span>
                                    </Tooltip>
                                </TableCell>
                            )}
                            {columns.map(column => (
                                <TableCell align='left' className='headers' sx={{...tableCellSx}}>
                                    {column.title.toUpperCase()}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {locations.map((location) => (
                            <TableRow
                                key={location.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                {(comingFromUserForm || linkServiceProviders) && (
                                    <TableCell {...commonTableCellProps}>
                                        <Tooltip title={checkboxDisabled ? "Enable Region to assign this location" : ""}>
                                            <span>
                                                <CheckBox
                                                    checked={state.assignedLocationIds.includes(location.id)}
                                                    onChange={() => handleLocationCheck({ regionId, checkedLocationId: location.id })}
                                                    disabled={!state.enabledRegionIds.includes(regionId)}
                                                />
                                            </span>
                                        </Tooltip>
                                    </TableCell>      
                                )}
                                <TableCell className='location-name' component="th" scope="row" sx={{...tableCellSx}}>
                                    {location.name}
                                </TableCell>
                                <TableCell {...commonTableCellProps}>
                                    {location.code}
                                </TableCell>
                                <TableCell {...commonTableCellProps}>
                                    {location.locationTypeName}
                                </TableCell>
                                <TableCell {...commonTableCellProps}>
                                    {location.activeSystemCount}
                                </TableCell>
                                <TableCell {...commonTableCellProps}>
                                    {location.address}
                                </TableCell>
                                <TableCell {...commonTableCellProps}>
                                    {location.state}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default InstanceAssociationsTable;
